export const ComponentMap = {
  SIGN_IN: 'SignInPage',
  SIGN_UP: 'SignUpPage',
  AUTH_SELECT: 'AuthSelect',
  FACILITY_SELECT: 'FacilitySelect',
  NEW_PASSWORD: 'NewPasswordPage',
};

export const pageNameToModuleMap = {
  [ComponentMap.SIGN_IN]: 'signIn',
};
